import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { cn as c } from "../../../lib/utils.js";
import { AnimatePresence as f, motion as r } from "framer-motion";
import { Info as b, XCircle as u, AlertTriangle as x, CheckCircle2 as w, X as v } from "lucide-react";
import { useState as y, useEffect as N } from "react";
const z = {
  success: {
    bg: "bg-emerald-500",
    splash: "bg-emerald-400",
    text: "text-white",
    icon: e(w, { size: 20 })
  },
  warning: {
    bg: "bg-amber-500",
    splash: "bg-amber-400",
    text: "text-white",
    icon: e(x, { size: 20 })
  },
  error: {
    bg: "bg-red-500",
    splash: "bg-red-400",
    text: "text-white",
    icon: e(u, { size: 20 })
  },
  info: {
    bg: "bg-sky-500",
    splash: "bg-sky-400",
    text: "text-white",
    icon: e(b, { size: 20 })
  }
}, k = {
  type: "spring",
  stiffness: 350,
  damping: 30
};
function X({ variant: o, title: h, description: s, duration: i = 5e3, onDismiss: t, className: d }) {
  const [p, n] = y(!0), a = z[o];
  N(() => {
    if (i <= 0)
      return;
    const g = setTimeout(() => {
      n(!1), t == null || t();
    }, i);
    return () => clearTimeout(g);
  }, [i, t]);
  const m = () => {
    n(!1), t == null || t();
  };
  return e(f, { children: p && l(r.div, { initial: { opacity: 0, x: 80, scale: 0.95 }, animate: { opacity: 1, x: 0, scale: 1 }, exit: { opacity: 0, x: 80, scale: 0.95 }, transition: k, className: c("relative w-full overflow-hidden rounded-xl", a.bg, a.text, "shadow-xl", d), children: [e(r.div, { initial: { scale: 0, opacity: 0.6 }, animate: { scale: 4, opacity: 0 }, transition: { duration: 0.8, ease: "easeOut" }, className: c("absolute -top-4 -right-4 w-16 h-16 rounded-full", a.splash) }), l("div", { className: "relative z-10 flex items-start gap-3 p-4 pr-10", children: [e("span", { className: "flex-shrink-0 mt-0.5 opacity-90", children: a.icon }), l("div", { className: "flex-1 min-w-0", children: [e("p", { className: "text-sm font-semibold leading-tight", children: h }), s && e("p", { className: "mt-1 text-sm leading-snug opacity-85", children: s })] })] }), e("button", { onClick: m, className: "absolute top-3 right-3 z-10 p-1 rounded-full hover:bg-white/20 transition-colors cursor-pointer opacity-80 hover:opacity-100", children: e(v, { size: 14 }) }), i > 0 && e("div", { className: "absolute bottom-0 left-0 right-0 h-1 bg-black/10", children: e(r.div, { initial: { width: "100%" }, animate: { width: "0%" }, transition: { duration: i / 1e3, ease: "linear" }, className: "h-full bg-white/40 rounded-full" }) })] }) });
}
export {
  X as SplashedNotification
};
//# sourceMappingURL=SplashedNotification.js.map
